export enum OrderTrackingShipmentSetupIssue {
  CarrierUnresolved = "carrier_unresolved",
  CarrierUnavailable = "carrier_unavailable",
  RegistrationRejected = "registration_rejected",
}
